import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-session-location-time-slots',
  templateUrl: './form-session-location-time-slots.component.html',
  styleUrls: ['./form-session-location-time-slots.component.scss']
})
export class FormSessionLocationTimeSlotsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
